import React from 'react';
import {
  Row,
  Col,
  Grid,
  Form,
  Panel,
  PanelBody,
  PanelHeader,
  FormControl,
  PanelContainer,
  Alert,
  Icon,
  FormGroup,
  ControlLabel,
} from '@sketchpixy/rubix';
import path from 'path';

import * as urls from '../api/url';

let globalLocalPath = '/';
let dz = null;

// 파일 업로드 용량 제한. 단위는 MB
const UPLOAD_FILE_SIZE_LIMIT = 800;
// 한번에 업로드 가능한 파일 개수 제한
const UPLOAD_FILE_COUNT_LIMIT = 500;
const ROOT_PATH = '/';

export default class Dropzone extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPath: ROOT_PATH,
    };

    globalLocalPath = ROOT_PATH;
  }

  componentDidMount() {
    Messenger.options = {
      theme: 'flat',
    };

    $('#my-awesome-dropzone').dropzone({
      url: urls.uploadAsset,
      paramName: 'file', // The name that will be used to transfer the file
      maxFilesize: UPLOAD_FILE_SIZE_LIMIT, // MB
      timeout: 1200000,
      autoProcessQueue: true,
      parallelUploads: 1,
      maxFiles: UPLOAD_FILE_COUNT_LIMIT,
      headers: {
        access_token: localStorage.getItem('access_token'),
      },
      params: {
        serviceTypeName: this.props.serviceTypeName,
        assetVersionId: this.props.assetVersionId,
        fileVersion: '1.0.0',
      },

      init: function() {
        dz = this;
        this.on('sending', function(file, xhr, formData) {
          if (!file.fullPath) {
            formData.append('currentPath', globalLocalPath);
            return;
          }

          let fullPath = file.fullPath;
          fullPath = fullPath.trim();
          let dirName = path.dirname(fullPath);
          let currentPath = '';
          if (globalLocalPath !== '/') {
            currentPath = globalLocalPath;
          }
          currentPath += `/${dirName}`;
          formData.append('currentPath', currentPath);
        });

        this.on('complete', function() {
          $('.dz-success-mark > *, .dz-error-mark > *').hide();
        });
      }, accept: (file, done) => {
        done();
      }, success: function(file, response) {
        if (response['statusMessage'] !== 'OK') {
          this.defaultOptions.error(file, 'error');
        } else {
          this.defaultOptions.success(file);
        }
      }, error: function(file, msg) {
        Messenger().post({
          type: 'error',
          message: msg + ' \n upload canceled =>' + file.fullPath,
          showCloseButton: true,
        });
      },
    });
  }

  onSelectChanged = (e) => {
    let val = e.currentTarget.value;
    let currentPath = null;
    if (val !== 'null') {
      currentPath = val;
    }
    globalLocalPath = currentPath;
    this.setState({currentPath});

    dz.removeAllFiles(true);
  };

  render() {
    return (
        <Row>
          <Col sm={12}>
            <PanelContainer controls={false}>
              <Panel>
                <PanelHeader className='bg-blue fg-white' style={{margin: 0}}>
                  <Grid>
                    <Row>
                      <Col xs={12}>
                        <h3>Drop your files</h3>
                      </Col>
                    </Row>
                  </Grid>
                </PanelHeader>
                <PanelBody>
                  <Grid>
                    <Row>
                      <Col xs={12}>
                        <br />
                        <Alert bsStyle="danger">
                          <h4>
                            <Icon glyph='icon-fontello-alert' className='fg-red' style={{fontSize: 24}} />
                            &nbsp;업로드 할 파일의 <strong>서비스 이름, 버전 코드</strong>를 반드시 확인해주세요.
                          </h4>
                          &gt; 파일은 놓여지는 순간 자동으로 업로드됩니다.<br />
                          &gt; Service name : {this.props.serviceName}<br />
                          &gt; Version code : {this.props.assetVersion}<br />
                          &gt; Version code 를 변경 하시려면 현재 창을 닫은 뒤 파일 리스트에서 Change Asset Version Code 버튼을 선택해주세요.<br />
                          <br />
                          <FormGroup controlId="formControlsSelect">
                            <ControlLabel>&gt; 특정 폴더에 업로드</ControlLabel>
                            <FormControl componentClass="select" placeholder="select" onChange={this.onSelectChanged}>
                              <option value="/">/</option>
                              {
                                this.props.folders.map((folder, index) => {
                                  if (folder === ROOT_PATH) {
                                    return null;
                                  } else {
                                    return <option key={index} value={folder}>{folder}</option>;
                                  }
                                })
                              }
                            </FormControl>
                          </FormGroup>
                        </Alert>
                        <Form className='dropzone' id='my-awesome-dropzone' />
                      </Col>
                    </Row>
                  </Grid>
                </PanelBody>
              </Panel>
            </PanelContainer>
          </Col>
        </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Dropzone.js